<template>
	<div
		class="team_member_list"
		:style="{ '--padding-top': paddingTop, '--padding-bottom': paddingBottom }"
	>
		<div class="container">
			<div
				class="inner"
				:class="{ top_border: showTopBorder === 'yes' }"
			>
				<h2
					v-if="title"
					v-html="title"
				></h2>
				<team-member-list-item
					v-for="(team_member, index) in JSON.parse(team_members)"
					:key="index"
					:title="team_member.title ? team_member.title : 'No title'"
					:image="
            team_member.featured_image
              ? team_member.featured_image.large
              : team_member.featured_image"
					:text="team_member.excerpt ? team_member.excerpt : 'No excerpt'"
					:link="team_member.permalink ? team_member.permalink : 'No permalink'"
				></team-member-list-item>
			</div>
		</div>
	</div>
</template>

<script>
// import axios from 'axios';
import TeamMemberListItem from './TeamMemberListItem.vue';

export default {
	data() {
		return {};
	},

	props: {
		team_members: {},
		title: {
			default: null,
		},
		showTopBorder: {
			default: 'no',
		},
		paddingTop: {
			default: '80px',
		},
		paddingBottom: {
			default: '80px',
		},
	},

	computed: {},

	watch: {},

	methods: {
		stripped(arg) {
			return arg.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, '');
		},
	},

	components: {
		TeamMemberListItem,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/common/variables';

.team_member_list {
	.inner {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: $spacer * 2;
		padding: var(--padding-top) 0 var(--padding-bottom);

		@media (max-width: $lg) {
			grid-template-columns: 1fr;
			padding: 0 0 $spacer * 2;
			gap: $spacer;
		}

		&.top_border {
			border-top: 1px solid $cpmec-blue;
			padding-top: $spacer * 2;
		}

		h2 {
			grid-column: span 3;
			margin: 0;
			color: $cpmec-blue;
			font-family: $font-family;
			font-size: 36px;
			font-weight: normal;

			@media (max-width: $lg) {
				grid-column: span 1;
				padding: 0 $spacer;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/TeamMemberList.vue